import {notification, Tooltip} from "antd";
import {useEffect, useState} from "react";
import {v4} from "uuid";
import EmptyLine from "../../app-components/outputs/EmptyLine";
import CheckCSName from "../../app-components/outputs/CheckCSName";
import {useAppContext} from "../../context/AppContext";
import ComparisonCSName from "../../app-components/outputs/ComparisonCSName";
import React from 'react';

export default function ResultTable({children, style = {}, footer, maxWidth, hideToolbar, enableReactRender, data, scrollable, ...props}) {
    const id = v4();
    const fontFamily = window.location.pathname.includes('/app/report') ? 'Calibri' : 'Segoe ui'
    const fontSize = window.location.pathname.includes('/app/report') ? '11pt' : '9pt'

    const {getSelectedHistory} = useAppContext()

    const [hover, setHover] = useState(false)


    const copy = async () => {
        const elTable = document.getElementById(id).getElementsByTagName('table')[0]
        const toolRow = document.getElementById(`tool-row-${id}`)
        if(toolRow) {
            toolRow.style.display = 'none'
        }

        const { ClipboardItem } = window;

        if (document.createRange && window.getSelection && elTable) {
            const range = document.createRange();
            range.selectNodeContents(elTable);

            try {
                await navigator.clipboard.write([
                    new ClipboardItem({
                        "text/html": new Blob([elTable.outerHTML], { type: "text/html" })
                    })
                ]);

                notification.success({
                    message: 'Table copied to clipboard!'
                });
            } catch (e) {
                console.error('Failed to copy table: ', e);
                notification.error({
                    message: 'Failed to copy table.'
                });
            }
        }

        if(toolRow) {
            toolRow.style.display = 'block'
        }
    }

    const getColumnCount = () => {
        try {
            // children[0] genelde thead olur, onun içindeki ilk satırın th/td sayısına bakıyoruz
            const head = React.Children.toArray(children).find(
                child => child.type === 'thead' || child.type === 'tbody'
            );

            if (head && head.props.children) {
                const firstRow = React.Children.toArray(head.props.children)[0];
                if (firstRow && firstRow.props.children) {
                    return React.Children.toArray(firstRow.props.children).length;
                }
            }
        } catch (e) {
            console.warn("Sütun sayısı hesaplanamadı, varsayılan değer kullanılıyor.");
        }
        return 1; // Fallback
    };

    const columnCount = getColumnCount();

    const _table = (
        <table
            {...props}
            style={{ fontFamily: fontFamily, fontSize: fontSize, ...style }}
        >
            {children}
            {footer && (
                <tfoot>
                <tr>
                    <td colSpan={columnCount}>
                        {footer}
                    </td>
                </tr>
                </tfoot>
            )}
        </table>
    );

    return (
        <div
            style={{ display: 'flex', alignItems: 'end', gap: 4 }}
            id={id}
            onMouseMove={(e) => {
                setHover(true);
            }}
            onMouseLeave={(e) => {
                setHover(false);
            }}
        >
            <div style={{ maxWidth: maxWidth || '22cm' }}>
                {data?.length > 0 && (
                    <div
                        style={{
                            fontFamily: fontFamily,
                            fontSize: fontSize,
                        }}
                    >
                        <EmptyLine/>
                        {(getSelectedHistory()?.type === 'Check' || !getSelectedHistory()?.type) && (
                            <CheckCSName csNameList={data}/>
                        )}
                        {getSelectedHistory()?.type ===
                            'Comparison' && (
                                <ComparisonCSName
                                    csNameList={data}
                                />
                            )}
                        <EmptyLine/>
                    </div>
                )}
                <Tooltip
                    title={
                        <a style={{color: 'white'}} onClick={copy}>
                            Copy
                        </a>
                    }
                    placement={'topLeft'}
                >
                    {scrollable && (
                        <div style={{overflowY: 'auto', height: scrollable?.height || 500}}>
                            {_table}
                        </div>
                    )}
                    {
                        !scrollable && (_table)
                    }
                </Tooltip>
            </div>
        </div>
    );
}